<template>
  <div class="bg-bs-bg dark:bg-bs-dark-bg">
    
    <div v-if="$route.name !== 'AccaShare'" class="fixed bottom-44 left-0 bg-white rounded-tr-lg rounded-br-lg shadow-xl p-5 cursor-pointer dark:bg-bs-blue-dark  z-20" @click="toggleDarkMode">
      <font-awesome-icon :icon="['fa','adjust']" class="text-bs-dark-bg dark:text-bs-dark-bg" size="lg" />
    </div>
   <!--  <div class="fixed bottom-24 right-0 bg-bs-red rounded-tl-lg rounded-bl-lg shadow-xl p-5 cursor-pointer z-20" @click="refreshApp" v-if="updateExists" >
      <font-awesome-icon :icon="['fa','sync']" class="text-white" size="lg" />
    </div> -->
    <goal-toast />
    <router-view v-if="ready" />
  </div>
</template>
<script>
import firebase from "@/firebase";
import GoalToast from "@/components/atoms/GoalToast.vue";
export default {
  components: { GoalToast },
  data: function() {
    return {
      ready: false,
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  created: function() {
    this.getUser();

    document.addEventListener(
      'updatedWebApp', this.showRefreshUI, { once: true }
    );
    if (navigator.serviceWorker) {  
      navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
      );
    }
  },
  methods: {
    getUser: async function() {
      try {
        let user = await firebase.getCurrentUser();
        let token = await user.getIdToken();
        this.$store.commit("setAccessToken", token);
        this.$store.commit("setUser", user.toJSON());
        // Custom claim "admin" gates /admin/* routes + the admin sidebar section.
        // Set via MobileAPI/scripts/grant-admin.js. New token needed after revoke,
        // hence the explicit force-refresh on getIdTokenResult below.
        try {
          const tokenResult = await user.getIdTokenResult();
          this.$store.commit("setAdmin", tokenResult.claims && tokenResult.claims.admin === true);
        } catch (e) {
          this.$store.commit("setAdmin", false);
        }
        this.$store.dispatch('getLiveData')
      } catch (e) {
        console.log(e);
      }
      this.ready = true;
    },
    toggleDarkMode: function(){
      this.$store.commit('toggleTheme')   
    },
    showRefreshUI (e) {
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp: function(){
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    }
  },
};
</script>
<style>
#app {
  font-family: Poppins, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}


</style>
